import { render, staticRenderFns } from "./AccountActionSkeleton.vue?vue&type=template&id=87dd888e&scoped=true"
import script from "./AccountActionSkeleton.vue?vue&type=script&lang=js"
export * from "./AccountActionSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AccountActionSkeleton.vue?vue&type=style&index=0&id=87dd888e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dd888e",
  null
  
)

export default component.exports